import { rem } from "@certn/cascadia";
import { BasicButton, SectionMessage } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { useApplication } from "../ApplicationContext";

type NotStartedProps = {
  sectionKey: string;
  showErrors: boolean;
};

export function NotStarted(props: NotStartedProps) {
  const { sectionKey } = props;
  const { navigateToSection, incompleteSectionSummaryRef } = useApplication();

  return (
    <div ref={incompleteSectionSummaryRef}>
      <SectionMessage
        fontSize="sm"
        icon="error"
        sectionTitle="Incomplete step"
        type="danger"
      />
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: rem("space-3"),
          padding: rem("space-4"),
        })}
      >
        <Trans>This step has not been completed yet.</Trans>
        <BasicButton
          size="medium"
          onPress={() => navigateToSection(sectionKey)}
          testID={`summary-${sectionKey}-section-complete-this-step-button`}
        >
          <Trans>Complete this step</Trans>
        </BasicButton>
      </div>
    </div>
  );
}
